import { AktenIdentifier, GenericChangeEventWithoutPassWithRelationsSchema } from '@dpa/common/dist'
import { trpc } from '../../../App'

export function useAkteAuditLog(identifier: AktenIdentifier) {
  const audit = trpc.audit.useQuery({ entryId: identifier.id, entryType: 'akte' })
  return audit.data == undefined
    ? undefined
    : GenericChangeEventWithoutPassWithRelationsSchema.array().parse(audit.data)
}
